// Adrese po okruženju dolaze iz .env.development, .env.production i .env.test.
export const apiUrl = process.env.REACT_APP_BBA_API_URL || ''
export const identityApiUrl = process.env.REACT_APP_IDENTITY_API_URL || ''

const identityWebUrl = process.env.REACT_APP_IDENTITY_WEB_URL || ''

// Nakon prijave korisnik se vraća na okruženje s kojeg je došao.
export const identityLoginUrl = () =>
  `${identityWebUrl}/auth?redirectTo=${window.location.origin}/dashboard`
